import { ApplicationInsights } from '@microsoft/applicationinsights-web';

const appInsights = new ApplicationInsights({
    config: {
        instrumentationKey: window.APPINSIGHTS_INSTRUMENTATIONKEY,
        disableCookiesUsage: true,
        disableCorrelationHeaders: true,
        isStorageUseDisabled: true,
    }
});
appInsights.loadAppInsights();

// Remove unnecessary user data tracking
appInsights.addTelemetryInitializer((envelope) => {
    const telemetryItem = envelope.data.baseData;
    if (telemetryItem) {
        delete telemetryItem.userId;
        delete telemetryItem.authenticatedUserId;
        delete telemetryItem.accountId;
    }
    envelope.tags['ai.location.ip'] = '0.0.0.0'; // Mask IP address
});

appInsights.trackPageView(); // Manually call trackPageView to collect page load times